'use client';
import { ProductCardContext } from '.';
import { useTranslations } from 'next-intl';
import { ComponentProps, ComponentPropsWithoutRef, useContext } from 'react';
import { useIsVenueRouterPage } from '@/features/venue-router';
import { EventService } from '@/shared/lib/event-service';
import { Button } from '@/shared/ui/button';
import { Icon as IconCmp } from '@/shared/ui/icon';
import { Layout } from '@/shared/ui/layout';
import { ModalService } from '@/shared/ui/modal/ModalService';

type Props = ComponentProps<typeof Layout>;
export const ProductCardAddToCartButton = ({ children, ...props }: Props) => {
    const { hash, id, selectedVariantId, addToCartAction } = useContext(ProductCardContext);
    const isVenueRouterPage = useIsVenueRouterPage();

    const handleClick = () => {
        // selectVenue režim (rozcestník) má vždy otevřít venue picker,
        // nezávisle na openMode karty.
        if (addToCartAction === 'selectVenue') {
            ModalService.showPrefab('SelectVenueModal', {
                availableForItemId: id,
                allowSelectCurrent: isVenueRouterPage,
            });
            return;
        }

        // Tlačítko "Přidat do košíku" vždy otevře addons modal pro výběr varianty/doplňků,
        // nezávisle na productDetail.openMode (page/modal).
        EventService.trigger('product:addons-menu:view-detail', {
            productHash: hash,
            initialVariant: selectedVariantId,
        });
    };

    return (
        <Layout
            element={Button}
            type="button"
            data-testid="product-card-add-to-cart-button"
            onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleClick();
            }}
            {...props}
        >
            {children}
        </Layout>
    );
};

type IconProps = ComponentProps<typeof Layout>;

export const Icon = (props: IconProps) => {
    return (
        <Layout
            element={(svgProps: ComponentPropsWithoutRef<'svg'>) => <IconCmp name="plus" {...svgProps} />}
            width={24}
            height={24}
            {...props}
        />
    );
};

type TextProps = ComponentProps<typeof Layout>;
export const Text = (props: TextProps) => {
    const t = useTranslations();
    return (
        <Layout element="span" {...props}>
            {t('WORDS.ADD_TO_CART')}
        </Layout>
    );
};
